<script setup>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

const props = defineProps({
  domain: { type: String, required: false, default: null },
  name: { type: String, required: false, default: '' },
  field: { type: Object, required: false, default: null },
  dynamicLabel: { type: Boolean, default: false },
  specificLabel: { type: String, default: null },
  label: { type: String, default: null },
  userSelectAllowGrow: { type: Boolean, default: false },
  addUser: { type: Boolean, default: false },
  addUserPlaceholder: { type: Boolean, default: false },
  wrapperClasses: { type: String, default: null },
})

const { t, te } = useI18n()

const isLabelDivCol6 = computed(() => {
  const noUserGrow =
    !props.userSelectAllowGrow ||
    ((!props.addUser || false) && (!props.addUserPlaceholder || !props.addUserPlaceholder))

  return props.labelLeftEqual && noUserGrow
})

const isLabelDivCol4 = computed(() => {
  const canAddUserOrDirector = (props.addUser || false) && true
  const canUsePlaceholder = props.addUserPlaceholder && props.addUserPlaceholder

  return props.userSelectAllowGrow && props.labelLeftEqual && (canAddUserOrDirector || canUsePlaceholder)
})

const fieldLabel = computed(() => {
  let domain = props.domain
  let field = props.name
  let specific = props.specificLabel

  if (props.label != null) {
    return props.label
  }

  if (props.domain == null) {
    const segments = field.split('.')
    domain = segments.shift()
    field = segments.join('.')
  }

  const translationKey = `${domain}.fields.${field}.label`

  if (specific != null) {
    let specificTranslationKey = `${translationKey}.${specific}`
    return te(specificTranslationKey) ? t(specificTranslationKey) : t(`${translationKey}.default`)
  }

  const generatedLabel = t(te(`${translationKey}.default`) ? `${translationKey}.default` : translationKey)

  return generatedLabel === translationKey ? null : generatedLabel
})

const labelClass = computed(() => {
  return {
    'fs-16': true,
    'form-label-font': true,
    'd-none': props.field && props.field.options && props.field.options.display === false,
    'd-flex': props.wrapperClasses,
    required:
      props.field &&
      props.field.options &&
      props.field.options.required &&
      !(props.field && props.field.options && props.field.options.disabled),
  }
})

const labelDivClasses = computed(() => {
  return props.wrapperClasses
    ? {
        [props.wrapperClasses]: true,
      }
    : {
        'col-md-12': props.labelLeft && !isLabelDivCol6.value && !isLabelDivCol4.value,
        'col-md-6': isLabelDivCol6.value && !isLabelDivCol4.value,
        'col-md-4': isLabelDivCol4.value && !isLabelDivCol6.value,
        'd-flex': true,
        'justify-content-between': true,
      }
})
</script>

<template>
  <div v-if="!field || field.type !== 'hidden'" :class="labelDivClasses">
    <label v-if="fieldLabel" :for="name" :class="labelClass">
      <div>{{ fieldLabel }}</div>
    </label>
    <slot />
  </div>
</template>
